import { put, takeLatest } from "redux-saga/effects";
import * as types from "../../actions/actionTypes";
import { reset } from "redux-form";

export function* watcherSubItem() {
  yield takeLatest(types.CLOSE_PROJECT_SUB_ITEMS_ADD_MODAL, workerAddSubItemClose);
}

function* workerAddSubItemClose() {
  try {
    yield put(reset("projectSubItemForm"));
  } catch (error) {
    console.log(error);
  }
}